import { createContext, useContext } from "react";
import type { AccountMode, MarketLeverages } from "./types";

export type TradingSettingsContextType = {
  accountMode: AccountMode;
  marketLeverages: MarketLeverages;
  slippageTolerance: number | null;
  /** Global default leverage for new markets (user-configurable) */
  defaultLeverage: number;
  getLeverage: (market: string) => number;
  setLeverage: (market: string, leverage: number) => void;
  setAccountMode: (mode: AccountMode) => void;
  setSlippageTolerance: (tolerance: number | null) => void;
  /** Update the global default leverage */
  setDefaultLeverage: (leverage: number) => void;
};

export const TradingSettingsContext = createContext<
  TradingSettingsContextType | undefined
>(undefined);

export const useTradingSettings = () => {
  const context = useContext(TradingSettingsContext);
  if (!context) {
    throw new Error(
      "useTradingSettings must be used within TradingSettingsProvider"
    );
  }
  return context;
};

